import { MY_TEAM_URL_FRAGMENT, MY_TEAM_CERTIFICATIONS_URL_FRAGMENT, MY_TEAM_MEMBERS_URL_FRAGMENT, MY_TEAM_CERTIFICATIONS_BY_TEAM_REDIRECT_URL_FRAGMENT, MY_TEAM_PLAYLISTS_REDIRECT_URL_FRAGMENT } from 'academy-navigation-lib/routes/academyRoutePaths';
export { LEGACY_MY_TEAM_URL_FRAGMENT } from 'academy-navigation-lib/routes/academyRoutePaths';
export const MY_TEAM_BASE_FRAGMENT = MY_TEAM_URL_FRAGMENT;
export const CERTIFICATIONS_BY_TEAM_PATH = MY_TEAM_CERTIFICATIONS_BY_TEAM_REDIRECT_URL_FRAGMENT;
export const ACTIVE_CERTIFICATIONS_BY_TEAM_PATH = `${CERTIFICATIONS_BY_TEAM_PATH}/active`;
export const IN_PROGRESS_CERTIFICATIONS_BY_TEAM_PATH = `${CERTIFICATIONS_BY_TEAM_PATH}/in-progress`;
export const EXPIRED_CERTIFICATIONS_BY_TEAM_PATH = `${CERTIFICATIONS_BY_TEAM_PATH}/expired`;
export const CERTIFICATIONS_INDEX_PATH = MY_TEAM_CERTIFICATIONS_URL_FRAGMENT;
export const CERTIFICATIONS_PROFILE_BASE = CERTIFICATIONS_INDEX_PATH;
export const TEAM_MEMBERS_PATH = MY_TEAM_MEMBERS_URL_FRAGMENT;

// Playlists
export const PLAYLISTS_BASE_PATH = MY_TEAM_PLAYLISTS_REDIRECT_URL_FRAGMENT;
export const ALL_PLAYLISTS_PATH = `${PLAYLISTS_BASE_PATH}/all`;
export const COMPLETED_PLAYLISTS_PATH = `${PLAYLISTS_BASE_PATH}/completed`;
export const INCOMPLETE_PLAYLISTS_PATH = `${PLAYLISTS_BASE_PATH}/incomplete`;